import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import id from "../../../messages/id.json"
import en from "../../../messages/en.json"

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: "en",
    lng: "id",
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: en
      },
      id: {
        translation: id
      }
    }
  })

export default i18n

export const lngs = {
  id: { nativeName: "Id" },
  en: { nativeName: "En" }
}
